<template lang="pug">
.slider-chart
  .v-input.v-input--slider.v-input--slider--ticks.v-input--is-label-active.v-input--is-dirty.theme--light
    .v-input__control
      .v-input__slot
        span.v-label.theme--light.v-label--percentil {{ label }}
        .v-slider(style='margin-top: -5px;')
          .v-slider__track__container
            .v-slider__track(style='left: 5%; right: auto; width: 90%; border-style: solid; border-width: 1px; opacity: 0.4;')
            //- .v-slider__track-fill.primary(style='left: 0px; right: auto; width: 50%;')
          .v-slider__ticks-container
            span.v-slider__ticks.v-slider__ticks--always-show(style='opacity: 0.4; border-width: 1px; height: 18px; transform: translateX(-1px) translateY(-8px); left: 5%;')
            span.v-slider__ticks.v-slider__ticks--always-show(style='opacity: 0.4; border-width: 1px; height: 14px; transform: translateX(-1px) translateY(-6px); left: 50%;')
            span.v-slider__ticks.v-slider__ticks--always-show(style='opacity: 0.4; border-width: 1px; height: 18px; transform: translateX(-1px) translateY(-8px); left: 95%;')
          .v-slider__thumb-container.primary--text(v-if="percentil != null" :style='`left: ${percentil}%; margin-left: 3px;`')
            .v-slider__thumb(:title='`${Math.round(percentil)} %`' :class='{ primary: percentil > 5 || percentil < 95, error: percentil < 5 || percentil > 95 }' style='width: 18px; height: 18px; border-style: solid; border-width: 9px;')
</template>


<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    value: {
      type: [Number, String]
    },
    label: {}
  },
  computed: {
    percentil () {
      let data
      if (typeof this.value === 'string') {
        data = Number(this.value)
      } else {
        data = this.value
      }

      if (data == null) return
      if (data === -701) return 0
      if (data === 701) return 100

      data = Math.min(Math.max(data, 0), 1)

      return data * 100
    }
  }
}
</script>

<style>
  .v-slider:not(.v-input--is-dirty) .v-slider__ticks:first-child {
    border-color: rgba(0,0,0,.87);
  }
  .v-label--percentil {
    max-width: 133%;
    left: 3px;
    font-size: 12px;
    -webkit-transform: translateY(-18px);
    transform: translateY(-22px);
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/components/charts/LineChart.vue